export const AppointmentType = {
  general: 'general',
  handover: 'handover',
  meeting: 'meeting',
  ownersMeeting: 'owners_meeting',
  onSite: 'on_site',
}

export const APPOINTMENT_TYPE_OPTIONS = [
  { label: 'Appointment.TypeGeneralKey', value: AppointmentType.general },
  { label: 'Appointment.TypeOnSiteKey', value: AppointmentType.onSite },
  { label: 'Appointment.TypeHandoverKey', value: AppointmentType.handover },
  { label: 'Appointment.TypeMeetingKey', value: AppointmentType.meeting },
  {
    label: 'Appointment.TypeOwnersMeetingKey',
    value: AppointmentType.ownersMeeting,
  },
]

export const APPOINTMENT_REMINDER_NONE = 0

// The company calendar_default_reminder_minutes (IU-1549) until the init serves it
export const APPOINTMENT_REMINDER_DEFAULT_MINUTES = 30

export const APPOINTMENT_REMINDER_OPTIONS = [
  { label: 'Appointment.ReminderNoneKey', value: APPOINTMENT_REMINDER_NONE },
  { label: 'Appointment.Reminder15MinutesKey', value: 15 },
  { label: 'Appointment.Reminder30MinutesKey', value: 30 },
  { label: 'Appointment.Reminder1HourKey', value: 60 },
  { label: 'Appointment.Reminder1DayKey', value: 1440 },
]

export const AppointmentParticipantKind = {
  external: 'external',
  internal: 'internal',
}

export const AppointmentSendState = {
  failed: 'failed',
  sent: 'sent',
}

export const AppointmentSendKind = {
  cancellation: 'cancellation',
  invitation: 'invitation',
  update: 'update',
}

export const AppointmentFollowUpPromptKind = {
  create: 'create',
  reschedule: 'reschedule',
}

export const AppointmentFollowUpAction = {
  apply: 'apply',
  release: 'release',
}

export const AppointmentCancelFollowUpAction = {
  clear: 'clear',
  keep: 'keep',
  revert: 'revert',
}

export const AppointmentCancelFollowUpBranch = {
  hidden: 'hidden',
  none: 'none',
  previous: 'previous',
  stale: 'stale',
}

export const APPOINTMENT_CANCEL_FOLLOW_UP_ACTIONS = {
  [AppointmentCancelFollowUpBranch.hidden]: [null],
  [AppointmentCancelFollowUpBranch.none]: [
    AppointmentCancelFollowUpAction.clear,
    AppointmentCancelFollowUpAction.keep,
  ],
  [AppointmentCancelFollowUpBranch.previous]: [
    AppointmentCancelFollowUpAction.revert,
    AppointmentCancelFollowUpAction.keep,
  ],
  [AppointmentCancelFollowUpBranch.stale]: [null],
}

export const AppointmentHistoryAction = {
  cancelled: 'appointment_cancelled',
  created: 'appointment_created',
  deleted: 'appointment_deleted',
  notificationFailed: 'appointment_notification_failed',
  notificationSent: 'appointment_notification_sent',
  participantsChanged: 'appointment_participants_changed',
  rescheduled: 'appointment_rescheduled',
  updateDueDate: 'update_due_date',
}

export const AppointmentHistoryLinkKind = {
  participant: 'participant',
  request: 'request',
}

export const AppointmentErrorCode = {
  dueDateChanged: 'due_date_changed',
  requestImmutable: 'request_immutable',
}

export const AppointmentsScopeParam = {
  building: 'building_id',
  emailThread: 'email_thread_id',
  flat: 'flat_id',
  request: 'request_id',
  resident: 'resident_id',
}

export const APPOINTMENTS_WIDGET_PAGE_SIZE = 3

export const APPOINTMENTS_TAB_PAGE_SIZE = 25

export const APPOINTMENTS_PAGE_SIZE_MAX = 100

export const APPOINTMENTS_FIRST_PAGE = 1

export const APPOINTMENT_HISTORY_PAGE_SIZE = 20

export const APPOINTMENT_HISTORY_FIRST_OFFSET = 0

export const APPOINTMENTS_LOADING_STATE = {
  data: null,
  isFailed: false,
  isLoading: true,
}

export const APPOINTMENT_MOCK_LATENCY = 400

export const APPOINTMENT_MOCK_FOLLOW_UP_HOUR = 7

export const APPOINTMENT_MOCK_FOLLOW_UP_FLOOR_MINUTE = 1

export const APPOINTMENT_MOCK_FOLLOW_UP_GUARD_MINUTES = 60

export const APPOINTMENT_MOCK_DAY_LOAD_LIMIT = 3

export const APPOINTMENT_MOCK_DAY_LOAD_REGULAR_COUNT = 1

export const APPOINTMENT_MOCK_DAY_LOAD_WEEKDAY_COUNTS = { 2: 2, 3: 3 }

export const APPOINTMENT_MOCK_ID_PREFIX = 'apt-'

export const APPOINTMENT_MOCK_REQUEST_NUMBER_PREFIX = 'SR-'

export const APPOINTMENT_MOCK_SCOPE_PARAM_COUNT = 1

export const APPOINTMENT_MOCK_FOLLOW_UP_RELEASED = {
  coupled: false,
  previous_due_date: null,
  written_value: null,
}

export const APPOINTMENT_MOCK_INTERNAL_FIELDS = [
  'deletedAt',
  'history',
  'numericId',
  'requestDueDate',
  'restoreJobEnabled',
  'timezone',
]

export const APPOINTMENT_MOCK_EDITABLE_FIELDS = [
  'appointment_type',
  'description',
  'end_at',
  'is_all_day',
  'location',
  'reminder_offset_minutes',
  'start_at',
  'title',
]

export const APPOINTMENT_MOCK_CREATED_PAYLOAD_FIELDS = [
  'end_at',
  'is_all_day',
  'start_at',
  'title',
]

export const APPOINTMENT_MOCK_REQUEST_COPIED_FIELDS = ['building', 'flat']

export const APPOINTMENT_MOCK_REQUEST_SUMMARY_FIELDS = ['id', 'number', 'title']

export const APPOINTMENT_MOCK_LIST_ANCHOR_FIELDS = {
  building: ['id', 'is_archived', 'name', 'url'],
  flat: ['id', 'name', 'url'],
  request: ['id', 'is_archived', 'number', 'title', 'url'],
  resident: ['id', 'name', 'url'],
}

export const APPOINTMENT_MOCK_LIST_TIE_FIELD = 'numericId'

export const APPOINTMENT_MOCK_LIST_INTERNAL_FIELDS = [
  APPOINTMENT_MOCK_LIST_TIE_FIELD,
]

export const APPOINTMENT_MOCK_LIST_UPCOMING_ORDER = ['asc', 'asc']

export const APPOINTMENT_MOCK_LIST_PAST_ORDER = ['desc', 'asc']

export const APPOINTMENTS_LIST_ENDPOINT =
  'idwell-api/api/v3/calendar/appointments/'
